import type { ReactNode } from 'react';

/**
 * Centered login layout reproducing AST2's login.php: the AST logo above a
 * narrow card. (css/login.css `.body-content` / `.ast-logo` / `.menu`.)
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="ast-login-body">
      <div className="ast-login-content">
        <div className="ast-login-logo" aria-label="American Security Title" />
        {children}
      </div>
    </div>
  );
}
